<template>
  <div>
    <DashboardTiles
      :tiles="filteredTiles"
      :currentUser="getCurrentUser"
      :currentCompany="getUserCompany"
    ></DashboardTiles>
  </div>
</template>

<script>
import DashboardTiles from "./DashTilesClaude.vue";

export default {
  props: ["tiles"],
  components: { DashboardTiles },
  computed: {
    getUserCompany() {
      return this.$store.getters.getUserCompany;
    },
    getCompanyLabels() {
      return this.$store.getters.getCompanyLabels;
    },
    getCurrentUser() {
      return this.$store.getters.getCurrentUser;
    },
  },
  watch: {
    tiles(newTiles) {
      this.filteredTiles = newTiles;
    },
  },
  mounted() {
    this.filteredTiles = this.tiles;
  },
  data: () => ({
    filteredTiles: [],
  }),
};
</script>

<style></style>
